import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '@/lib/api/apiClient';
import { ListNotificationsResponse } from '@inversor-hub/types';

export const LIST_NOTIFICATIONS_KEY = 'notifications';

export function useListNotifications() {
  return useQuery({
    queryKey: [LIST_NOTIFICATIONS_KEY],
    queryFn: async () => {
      return apiClient.get<ListNotificationsResponse>(`/notifications`);
    },
    select: (response) => response.data.data,
  });
}

export function useMarkNotificationAsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.post(`/notifications/${id}/read`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LIST_NOTIFICATIONS_KEY] });
    },
  });
}

export function useMarkAllNotificationsAsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      await apiClient.post(`/notifications/read-all`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LIST_NOTIFICATIONS_KEY] });
    },
  });
}
